export const GUIDE_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
// UTC instant + fixed elapsed days: timezone/DST changes cannot restart a tour.
// Existing onboarded accounts without metadata stay hidden until manual opening.
export function migrateGuide(value, existingUser, now = Date.now()) {
  return value && Number.isFinite(value.firstUse) ? value : { firstUse: now, dismissed: !!existingUser };
}
export function showGuide(state, now = Date.now()) {
  return !!state && !state.dismissed && now >= state.firstUse && now < state.firstUse + GUIDE_DAYS_MS;
}
